<template>
  <teleport v-if="teleportTarget" :to="teleportTarget">
    <nav :class="ns.b()" aria-label="业务模块">
      <button
        v-for="domain in domains"
        :key="domain.key"
        type="button"
        :class="[
          ns.e('item'),
          ns.is('active', isActive(domain.key)),
        ]"
        :aria-expanded="expandedKey === domain.key"
        @click="handleClick(domain.key, $event)"
      >
        {{ domain.title }}
      </button>
    </nav>
  </teleport>
  <nav v-else :class="ns.b()" aria-label="业务模块">
    <button
      v-for="domain in domains"
      :key="domain.key"
      type="button"
      :class="[
        ns.e('item'),
        ns.is('active', isActive(domain.key)),
      ]"
      :aria-expanded="expandedKey === domain.key"
      @click="handleClick(domain.key, $event)"
    >
      {{ domain.title }}
    </button>
  </nav>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import type { AppDomainItem } from './types'

defineOptions({
  name: 'ZAppDomainNav',
})

const props = withDefaults(
  defineProps<{
    domains?: AppDomainItem[]
    activeKey?: string
    expandedKey?: string
    teleportTo?: string | false
  }>(),
  {
    domains: () => [],
    activeKey: '',
    expandedKey: '',
    teleportTo: false,
  }
)

const emit = defineEmits<{
  select: [key: string, event: MouseEvent]
}>()

const ns = useNamespace('app-domain-nav')
const targetReady = ref(false)

const teleportTarget = computed(() => {
  if (props.teleportTo === false) return ''
  const selector = props.teleportTo || '#app-title-bar-menu'
  if (!targetReady.value) return ''
  if (typeof document === 'undefined') return ''
  return document.querySelector(selector) ? selector : ''
})

onMounted(() => {
  targetReady.value = true
})

function isActive(key: string) {
  if (props.expandedKey && props.expandedKey === key) return true
  return props.activeKey === key
}

function handleClick(key: string, event: MouseEvent) {
  emit('select', key, event)
}
</script>
